import icon from "../../assets/icon.svg";
import { useState, useEffect } from 'react';

export default function LaunchAnimation() {
  const [animationComplete, setAnimationComplete] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Start fade out animation after 2.5 seconds
    const fadeTimer = setTimeout(() => {
      setFadeOut(true);
    }, 2500);

    // Complete animation after fade out
    const completeTimer = setTimeout(() => {
      setAnimationComplete(true);
    }, 3500);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(completeTimer);
    };
  }, []);

  if (animationComplete) {
    return null; // Animation done, show main content
  }

  return (
    <div
      className={`fixed inset-0 z-[100] bg-background flex items-center justify-center transition-opacity duration-1000 ${
        fadeOut ? 'opacity-0' : 'opacity-100'
      }`}
    >
      {/* Animated particles */}
      <div className="absolute inset-0 overflow-hidden">
        {[...Array(15)].map((_, i) => (
          <div
            key={i}
            className="absolute bg-primary/20 rounded-full animate-pulse"
            style={{
              width: Math.random() * 6 + 3 + 'px',
              height: Math.random() * 6 + 3 + 'px',
              left: Math.random() * 100 + '%',
              top: Math.random() * 100 + '%',
              animationDelay: Math.random() * 2 + 's',
              animationDuration: Math.random() * 3 + 2 + 's'
            }}
          />
        ))}
      </div>

      {/* Main logo and text animation */}
      <div className="relative z-10 text-center">
        {/* Logo with scale animation */}
        <div className="mb-6 flex justify-center animate-bounce-slow">
          <div className="rounded-2xl flex items-center">
            <img className="w-20 h-20" src={icon} alt="" />
            <h1 className="text-5xl md:text-6xl font-bold text-dark animate-slide-up">
            Inter<span className="text-accent">link</span>
          </h1>
          </div>
        </div>

        {/* Brand name with staggered animation */}
        <div className="overflow-hidden">
          
        </div>

        {/* Tagline with delayed fade-in */}
        <p className="mt-4 text-lg text-dark/70 animate-fade-in-delayed">
          Connecting Ideas to Action
        </p>

        {/* Loading indicator */}
        <div className="mt-8 flex justify-center">
          <div className="w-48 h-1 bg-dark/10 rounded-full overflow-hidden">
            <div className="h-full bg-gradient-to-r from-primary to-accent rounded-full animate-loading-bar" />
          </div>
        </div>
      </div>

      {/* Custom animations */}
      <style>{`
        @keyframes bounce-slow {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }
        
        @keyframes slide-up {
          from {
            transform: translateY(20px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        
        @keyframes fade-in-delayed {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        
        @keyframes loading-bar {
          from {
            transform: translateX(-100%);
          }
          to {
            transform: translateX(100%);
          }
        }
        
        .animate-bounce-slow {
          animation: bounce-slow 2s ease-in-out infinite;
        }
        
        .animate-slide-up {
          animation: slide-up 0.8s ease-out forwards;
        }
        
        .animate-fade-in-delayed {
          animation: fade-in-delayed 0.8s ease-out 0.4s forwards;
          opacity: 0;
        }
        
        .animate-loading-bar {
          animation: loading-bar 2s ease-in-out forwards;
        }
      `}</style>
    </div>
  );
}